/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */

import { Button, TextField} from '@mui/material'
import { CallbackType, FRAuth, FRStep , FRLoginFailure, FRCallback} from '@forgerock/javascript-sdk';

import {CheckboxButtonGroup, FormContainer, TextFieldElement} from 'react-hook-form-mui'
import { useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { trees } from '../../../config';
import FormLayout from '../../layout/form';
import FormSection from '../../01-atoms/FormSection';
import Row from '../../01-atoms/Row';
import SuccessErrorModal, { MessageType } from '../../modals/SuccessErrorModal';
// import { isNil } from 'lodash';
import isNil from 'lodash/isNil';
import { getTextOutputCallBackByMessageType } from '../../../util/generalUtility';
import { BaseCallBackInterface } from './basInterface';
import styles from '../../../styles/FormLayout.module.css';
import CustomTextField from '../../../util/component/CustomTextField';



const ar = true; // Activate Required (can turn off for testing convenience)


export default function ValidateCode({ step, setStep,tree,messageType,setMessageType,
  message,setMessage }: BaseCallBackInterface) {

  const formContext = useForm<{}>({
    defaultValues: {
    }
  })
  

  //  used for the modal
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  
  const [isDisabled,setDisabled] = useState(false);
  const [bottomElement, setBottomElement] = useState<JSX.Element | undefined>()
  
  //  ---------------------METHODS-----------------------------------

  function fillStep(step: FRStep, data: any): void {
    setDisabled(true)
    handleClose();
    const fillStep = step;
    step.getStage() === "CheckCodeApp" ? fillStep.getCallbackOfType(CallbackType.NameCallback).setInputValue(data.requestor.code):fillStep.getCallbackOfType(CallbackType.PasswordCallback).setInputValue(data.requestor.code);
    setStep(fillStep);
    setTimeout(()=>{
      setDisabled(false);
    },2)
  }

  const handleSuccess = async (data: any) => {
    fillStep(step as FRStep, data);
    callNextStep();
  }

  const callNextStep=async()=>{
    let nextStep = await FRAuth.next(step as FRStep, { tree });
    setStep(nextStep)
    formContext.setValue("requestor.code" as never, ("" as string) as never)
  }

  const handleOpen = () => {
    setIsAlertOpen(true);
  };
  const handleClose = async () => {
    setIsAlertOpen(false);
    //Need to check for the flow with Asjad or client 
   /*  const nextStep = await FRAuth.start({ tree });
    setStep(nextStep); */
  };

  const resentCode = async(data:{callbackType:string,callbackValue:string,heading:string,type: string}) =>{
    const fillStep=step  
    switch(data.callbackType){
        case "ConfirmationCallback":
            fillStep.getCallbackOfType(CallbackType.ConfirmationCallback).setInputValue(data.callbackValue);
          break;
      }
      setStep(fillStep);
      await callNextStep();
  }

  const getMetaDataUiElements = () => {
    
    const metadataCallback: FRCallback[] = step.getCallbacksOfType(CallbackType.MetadataCallback);
    let uiElement = <></>
    if (!isNil(metadataCallback) && metadataCallback.length) {
      const data = metadataCallback[0].getOutputValue('data') as any;
      if (!!data) {
        switch (data.type) {
          case 'link':
            uiElement = <a className={styles.textstyle} href="javascript:void(0)" onClick={() => resentCode(data)}>{data.heading}</a>
            break;
          default:
            break;
        }
       
      }
     
    }
    return uiElement;
  }

  


  useEffect(()=>{
    if(!!step){
      const errorTextCallBack = getTextOutputCallBackByMessageType(step, '2');
      const infoTextCallBack = getTextOutputCallBackByMessageType(step, '1');
      const metadataCallback: FRCallback[] = step.getCallbacksOfType(CallbackType.MetadataCallback);
      if (!isNil(metadataCallback) && metadataCallback.length) {
        const data = metadataCallback[0].getOutputValue('data') as any;
      updateBottomElement(data)
      }
      console.log(infoTextCallBack)
      if (!isNil(errorTextCallBack)) {
        setIsAlertOpen(true)
        setMessageType(MessageType.error)
        setMessage(errorTextCallBack.getOutputByName('message', ''))

      }else if(!isNil(infoTextCallBack)){
        setIsAlertOpen(true)
        setMessageType(MessageType.info)
        setMessage(infoTextCallBack.getOutputByName('message',''))
        }
        
    }
  },[step])

  const handleBack = async (confirmationCallBack: FRCallback, step: FRStep) => {
    setDisabled(true);
    step.getCallbackOfType(CallbackType.ConfirmationCallback).setInputValue(1);
    let nextStep = await FRAuth.next(step as FRStep, { tree });
    handleClose();
    setStep(nextStep);
    setTimeout(() => {
      setDisabled(false);
    }, 2)
  }

  const updateBottomElement = (metaData:any) => {
    let uiElement: JSX.Element | undefined = undefined;
    let children: JSX.Element[] = []
    console.log(metaData)
    if (!!step && !!metaData['$confirmationCallBack']) {
      const confirmationCallbacks = step.getCallbacksOfType(CallbackType.ConfirmationCallback)
      if (!!confirmationCallbacks && confirmationCallbacks.length) {
        (confirmationCallbacks[0].getOutputValue('options') as any[]).forEach((option,index) => {
          if(index!==metaData.callbackValue){
          console.log(metaData['$confirmationCallBack']?.callbacks[index]?.isHalfWidth)
          const style:React.CSSProperties = metaData['$confirmationCallBack']?.callbacks[index]?.style ?  metaData['$confirmationCallBack']?.callbacks[index]?.style  : {}
          console.log(style)
          children.push(<button type={index === 0 ? 'submit' : 'button'} onClick={async () => {

            if (index === 1) {
              handleBack(confirmationCallbacks[0], step)
            }

          }} style={style} className={`accent-1 ${ styles.submit}`}  >{option}</button>)
        }})
        uiElement = <div className={styles.bottom}> {  metaData['$confirmationCallBack']?.requiredLabel ? <span className={styles.requiredLabel}>* Required field</span> : <></>}
         <div style={{width:'100%'}}> {children}</div>
        </div>
      }
    }
      return setBottomElement(uiElement);

  }
  
  const getSubheader = () => {
    // split the element and send it
    let subheadervalue = getTextOutputCallBackByMessageType(step,'0')?.getOutputByName("message",'Enter One Time Password sent to your email')
    let subheaderfinal = subheadervalue.split(":")
    return (`<div class="codeSubHeader">${subheaderfinal[0]}</div> <div class="emailDark"> ${subheaderfinal[1]} </div>`)
  }
  //  -----------------END METHODS-----------------------------------


  return (
    <FormContainer
      defaultValues={{}}
      formContext={formContext}
      onSuccess={handleSuccess}>
      <SuccessErrorModal
        open={isAlertOpen}
        type={messageType}
        handleClose={handleClose}
        message={message}/>
      <FormLayout 
        header={step.getHeader()}
        disabled={isDisabled}
        button={bottomElement}
        // subHeader={getTextOutputCallBackByMessageType(step,'0')?.getOutputByName("message",'Enter One Time Password sent to your email')}>
        subHeader={getSubheader()}>
        <FormSection>
          <CustomTextField
                className="lowHeight"
                id="requestor_code"
                name="requestor.code"
                label="Passcode"
                type="code"
                margin="normal"
                required={ar && true}
                fullWidth
              />
             {getMetaDataUiElements()}        
        </FormSection>
      </FormLayout>
    </FormContainer>
  );
}


